import { ResourcePage } from "@/components/resource-page"
import { z } from "zod"
import { Server } from "lucide-react"

const serverSchema = z.object({
  name: z.string().min(1, "Name is required"),
  type: z.enum(["marzban", "xray", "outline", "custom"]),
  api_url: z.string().optional(),
  api_key: z.string().optional(),
  location: z.string().optional(),
  country: z.string().max(2).optional(),
})

const serverColumns = [
  { key: "id", type: "text", options: { label: "ID" } },
  { key: "name", type: "text", options: { label: "Name" } },
  { key: "type", type: "status", options: { label: "Type" } },
  { key: "location", type: "text", options: { label: "Location" } },
  { key: "country", type: "text", options: { label: "Country" } },
  { key: "status", type: "status", options: { label: "Status" } },
  { key: "users_count", type: "number", options: { label: "Users" } },
  { key: "is_active", type: "boolean", options: { label: "Active" } },
]

const serverFormFields = [
  { name: "name", label: "Name", type: "text", placeholder: "Enter server name" },
  {
    name: "type",
    label: "Type",
    type: "select",
    options: [
      { value: "marzban", label: "Marzban" },
      { value: "xray", label: "Xray" },
      { value: "outline", label: "Outline" },
      { value: "custom", label: "Custom" },
    ],
  },
  { name: "api_url", label: "API URL", type: "text", placeholder: "https://panel.example.com" },
  { name: "api_key", label: "API Key", type: "text", placeholder: "Enter API key" },
  { name: "location", label: "Location", type: "text", placeholder: "Enter location" },
  { name: "country", label: "Country Code", type: "text", placeholder: "DE" },
]

export default function ServersPage() {
  return (
    <ResourcePage
      resource="panels"
      title="Servers"
      icon={Server}
      columns={serverColumns}
      formFields={serverFormFields}
      formSchema={serverSchema}
      searchPlaceholder="Search servers..."
    />
  )
}
